export type ArchiveTab = 
  | 'homepage'
  | 'journey'
  | 'journey-suffolk'
  | 'journey-essentials'
  | 'journey-why-they-came'
  | 'dentons'
  | 'gibbs'
  | 'giles'
  | 'roberts'
  | 'acknowledgement';

export const TAB_TO_PATH: Record<ArchiveTab, string> = {
  'homepage': '/homepage',
  'journey': '/the-journey',
  'journey-suffolk': '/the-journey/from-suffolk-to-the-southern-seas',
  'journey-essentials': '/the-journey/essentials-for-a-new-land',
  'journey-why-they-came': '/the-journey/why-they-came-around-the-curve-of-the-earth',
  'dentons': '/the-dentons',
  'gibbs': '/the-gibb-family',
  'giles': '/the-giles-family',
  'roberts': '/the-roberts-family',
  'acknowledgement': '/acknowledgement-and-thanks',
};

export function getTabFromPath(pathname: string): ArchiveTab {
  const cleanPath = pathname.toLowerCase().replace(/\/$/, '') || '/';
  if (cleanPath === '' || cleanPath === '/' || cleanPath === '/homepage') return 'homepage';
  if (cleanPath === '/the-journey') return 'journey';
  if (cleanPath === '/the-journey/from-suffolk-to-the-southern-seas') return 'journey-suffolk';
  if (cleanPath === '/the-journey/essentials-for-a-new-land') return 'journey-essentials';
  if (cleanPath === '/the-journey/why-they-came-around-the-curve-of-the-earth') return 'journey-why-they-came';
  if (cleanPath === '/the-dentons') return 'dentons';
  if (cleanPath === '/the-gibb-family' || cleanPath === '/the-gibbs-family' || cleanPath === '/the-gibb' || cleanPath === '/the-gibbs') return 'gibbs';
  if (cleanPath === '/the-giles-family' || cleanPath === '/the-giles') return 'giles';
  if (cleanPath === '/the-roberts-family' || cleanPath === '/the-roberts') return 'roberts';
  if (cleanPath === '/acknowledgement-and-thanks' || cleanPath === '/acknowledgements' || cleanPath === '/acknowledgement') return 'acknowledgement';
  return 'homepage';
}

export type Gender = 'male' | 'female' | 'other';

export interface LifeEvent {
  id: string;
  year: number;
  dateStr?: string;
  title: string;
  location: string;
  description: string;
  category: 'birth' | 'marriage' | 'military' | 'immigration' | 'career' | 'education' | 'passing' | 'achievement';
}

export interface SourceReference {
  title: string;
  section?: string;
  tab?: ArchiveTab;
  pageId?: string;
  description?: string;
}

export interface FamilyMember {
  id: string;
  firstName: string;
  lastName: string;
  maidenName?: string;
  gender: Gender;
  birthYear?: number;
  birthDate?: string;
  birthPlace?: string;
  deathYear?: number;
  deathDate?: string;
  deathPlace?: string;
  isLiving?: boolean;
  photoUrl?: string;
  image?: string;
  bio?: string;
  occupation?: string;
  generation?: number;
  branchTag: string; // e.g., "Denton Family", "Roberts Family", "Gibb Family", "Giles Family", "Negus Family"
  
  // Relationships
  fatherId?: string;
  motherId?: string;
  spouseIds: string[];
  childrenIds: string[];
  
  lifeEvents?: LifeEvent[];
  audioBioUrl?: string; // Audio story link
  sourceReferences?: SourceReference[];
}

export interface StoryComment {
  id: string;
  authorName: string;
  date: string;
  text: string;
  relationToFamily?: string;
}

export interface Story {
  id: string;
  title: string;
  year?: number;
  decade?: string;
  authorName: string;
  category: 'oral_history' | 'letter' | 'recipe' | 'biography' | 'event' | 'military';
  summary: string;
  content: string;
  coverImageUrl?: string;
  documentScanUrl?: string;
  transcription?: string;
  taggedMemberIds: string[];
  tags: string[];
  audioNarrationUrl?: string;
  dateAdded: string;
  comments: StoryComment[];
  likesCount: number;
}

export interface ArchiveItem {
  id: string;
  title: string;
  type: 'photo' | 'document' | 'letter' | 'certificate' | 'recipe';
  fileUrl: string;
  year?: number;
  decade: string;
  location?: string;
  description: string;
  transcribedText?: string;
  taggedMemberIds: string[];
  tags: string[];
  dateAdded: string;
  addedBy: string;
}

export type FontSizeOption = 'normal' | 'large' | 'xlarge';
export type ColorThemeOption = 'warm' | 'high-contrast' | 'sepia';

export interface AccessibilitySettings {
  fontSize: FontSizeOption;
  colorTheme: ColorThemeOption;
  textToSpeechEnabled: boolean;
  screenReaderFriendly: boolean;
}
